
/**
 * 메시지 상태 정보
 */
export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOfStatus = {
  isRead?: boolean;
};
